import { getCurrentAcademicYear } from "../../../../utils/smallHelpers";
import {SET_FORM_DATA} from "../graduatesHEOReducer";


const initialState = {
    year: getCurrentAcademicYear(),
    idOrg: "0",
    addschool: "0"
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
